import type { ICellRendererParams } from 'ag-grid-enterprise'

import { Badge } from '@fortem-monorepo/react-ui'

import type { BalanceDisplayRow } from '../balance-drafts'
import { getCouponResetTags } from '../coupon-reset-tags'

export const CouponResetCell = ({ value, data, node }: ICellRendererParams<BalanceDisplayRow, string[]>) => {
  const tags = getCouponResetTags(value, data?.value_date ?? node.aggData?.value_date)
  if (!tags.length) return null
  return (
    <div className="flex h-full items-center justify-center gap-1">
      {tags.map(({ date, label, tone }) => (
        <Badge
          key={date}
          title={date}
          variant="outline"
          theme={tone === 'purple' ? undefined : tone}
          className={tone === 'purple' ? 'border-purple-300 bg-purple-100 text-purple-600' : undefined}
        >
          {label}
        </Badge>
      ))}
    </div>
  )
}
